import { type Control } from 'react-hook-form';
import { SubscriptionPlansEnum } from '../../../subscription/entity';
import type { StockItemDefaultValuesType, StockItemFormUsagePurposeType } from '../../entity';
import { StockItemPurchaseForm } from './components/stock-item-purchase-form';
import { StockItemTabButtons } from './components/stock-item-tab-buttons';
import { StockItemNewForm } from './components/stock-item-new-form';
import { useStockItemForm } from './stock-item-form.hooks';
import { useSubscriptionPlan } from '@shared/store';

export type StockFormControl = Control<StockItemDefaultValuesType>;

type StockItemFormProps = Omit<
  ReturnType<typeof useStockItemForm>,
  'reset' | 'stocks' | 'isLoading' | 'createOrUpdateStockItemMutation' | 'handleSubmit'
> & { formUsagePurpose: StockItemFormUsagePurposeType };

export const StockItemForm = (props: StockItemFormProps) => {
  const { methods, isPurchaseStockItem, setIsPurchaseStockItem, formUsagePurpose } = props;

  const plan = useSubscriptionPlan();
  const isExpertPlan = plan === SubscriptionPlansEnum.EXPERT;
  const isOnlyShoppingForm = formUsagePurpose === 'purchase';
  const isPurchaseAndNewStockItemForm = formUsagePurpose === 'purchaseAndNewStockItem';
  const isNewStockItemForm = formUsagePurpose === 'stockItem';

  return (
    <>
      {isPurchaseAndNewStockItemForm && (
        <StockItemTabButtons
          isPurchaseStockItem={isPurchaseStockItem}
          setIsPurchaseStockItem={setIsPurchaseStockItem}
        />
      )}

      {isPurchaseStockItem || isOnlyShoppingForm ? (
        <StockItemPurchaseForm control={methods.control} unit={props.stockItem.unit} />
      ) : (
        (isPurchaseAndNewStockItemForm || isNewStockItemForm) && (
          <StockItemNewForm control={methods.control} isExpertPlan={isExpertPlan} />
        )
      )}
    </>
  );
};

export default StockItemForm;
